import React from 'react';
import { connect } from 'react-redux';
import ErrorBoundary from '../components/global/ErrorBoundary';
import { withContainerWrapper } from './ContainerWrapper';
import { ApplicationState } from '../reducers';

type OwnProps = {
  children: React.ReactNode;
};

type PropsFromRedux = {
  isInitialized: boolean;
  isFilterInitialized: boolean;
};
type Props = PropsFromRedux & OwnProps;

class BrandRouteWrapper extends React.Component<Props> {
  render() {
    const { isInitialized, isFilterInitialized, children } = this.props;

    if (!isInitialized || !isFilterInitialized) return null;
    return (
      <ErrorBoundary>
        <div className="h-full w-full">{children}</div>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  isInitialized: state.brand.currentBrand.isInitialized,
  isFilterInitialized: state.brand.currentBrand.isFilterInitialized,
});

const ConnectedContainerBrandWrapper = connect(mapStateToProps)(
  withContainerWrapper(BrandRouteWrapper)
);

export const withBrandRouteWrapper = (Component: React.ComponentType<any>) => (props: any) =>
  (
    <ConnectedContainerBrandWrapper>
      <Component {...props} />
    </ConnectedContainerBrandWrapper>
  );

export default ConnectedContainerBrandWrapper;
